import { render, staticRenderFns } from "./WorkingSectionExportLegend.vue?vue&type=template&id=57cbb04f&scoped=true&"
import script from "./WorkingSectionExportLegend.vue?vue&type=script&lang=js&"
export * from "./WorkingSectionExportLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cbb04f",
  null
  
)

export default component.exports